import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth-container" }
const _hoisted_2 = {
  key: 0,
  class: "view-toggle-container"
}
const _hoisted_3 = { class: "toggle-switch" }
const _hoisted_4 = {
  key: 1,
  class: "main-content"
}
const _hoisted_5 = { class: "auth-card" }
const _hoisted_6 = { class: "welcome-text" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = {
  key: 2,
  class: "main-content"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "verification-dialog" }
const _hoisted_13 = { class: "digit-inputs" }
const _hoisted_14 = ["onUpdate:modelValue", "onInput"]
const _hoisted_15 = {
  key: 0,
  class: "errors"
}
const _hoisted_16 = { class: "resend-row" }
const _hoisted_17 = { class: "forgot-password-dialog" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "auth-card" }
const _hoisted_21 = { class: "form-fields" }
const _hoisted_22 = {
  key: 0,
  class: "signup-row"
}
const _hoisted_23 = {
  key: 0,
  class: "errors"
}
const _hoisted_24 = {
  key: 0,
  class: "errors"
}
const _hoisted_25 = {
  key: 0,
  class: "errors"
}
const _hoisted_26 = {
  key: 0,
  class: "errors"
}
const _hoisted_27 = {
  key: 0,
  class: "forgot-password-row"
}
const _hoisted_28 = { class: "form-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_modern_dialog = _resolveComponent("modern-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(['toggle-btn', { active: _ctx.mode === 'login' }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchToLogin && _ctx.switchToLogin(...args)))
            }, " Log In ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(['toggle-btn', { active: _ctx.mode === 'signup' }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchToSignup && _ctx.switchToSignup(...args)))
            }, " Sign Up ", 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "title" }, "You are logged in", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _cache[17] || (_cache[17] = _createTextVNode("Welcome, ", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.userId), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_button, { onClick: _ctx.logout }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("Logout", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.mode === 'login' ? 'Welcome Back' : 'Create Account'), 1),
          _createVNode(_component_modern_dialog, {
            show: _ctx.isLoading || !!_ctx.error,
            title: _ctx.isLoading ? 'Authenticating...' : 'Error',
            type: "info",
            onClose: _ctx.handleError,
            "close-on-click-outside": !_ctx.isLoading,
            fixed: _ctx.isLoading,
            "show-actions": !_ctx.isLoading
          }, {
            default: _withCtx(() => [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Please wait, it will take a couple of seconds..."))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.error), 1))
            ]),
            _: 1
          }, 8, ["show", "title", "onClose", "close-on-click-outside", "fixed", "show-actions"]),
          _createVNode(_component_modern_dialog, {
            show: _ctx.showVerificationDialog,
            title: "Email Verification",
            type: "success",
            onClose: _ctx.closeVerificationDialog,
            "close-on-click-outside": false,
            large: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "dialog-subtitle" }, "Enter the 6-digit code sent to your email", -1)),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.verificationCode, (digit, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: index,
                      type: "text",
                      maxlength: "1",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.verificationCode[index]) = $event),
                      onInput: ($event: any) => (_ctx.handleDigitInput(index, $event)),
                      ref_for: true,
                      ref: (el) => _ctx.setDigitInputRef(index, el)
                    }, null, 40, _hoisted_14)), [
                      [_vModelText, _ctx.verificationCode[index]]
                    ])
                  }), 128))
                ]),
                (_ctx.verificationError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.verificationError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", null, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Didn't receive the confirmation code? ", -1)),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args)), ["prevent"])),
                      class: _normalizeClass({ disabled: _ctx.isLoading })
                    }, "Resend", 2)
                  ])
                ])
              ])
            ]),
            actions: _withCtx(() => [
              _createVNode(_component_base_button, { onClick: _ctx.submitVerificationCode }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("Submit", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_base_button, {
                mode: "flat",
                onClick: _ctx.closeVerificationDialog
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["show", "onClose"]),
          _createVNode(_component_modern_dialog, {
            show: _ctx.showForgotPasswordDialog,
            title: "Reset Password",
            type: "success",
            onClose: _ctx.closeForgotPasswordDialog,
            "close-on-click-outside": false,
            large: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                (!_ctx.resetPasswordStep)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _cache[24] || (_cache[24] = _createElementVNode("p", { class: "dialog-subtitle" }, "Enter your email to receive a reset code", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.resetEmail) = $event)),
                        placeholder: "Enter your email"
                      }, null, 512), [
                        [_vModelText, _ctx.resetEmail]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "dialog-subtitle" }, "Enter the reset code and your new password", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.resetCode) = $event)),
                        placeholder: "Enter reset code",
                        autocomplete: "off"
                      }, null, 512), [
                        [_vModelText, _ctx.resetCode]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPassword) = $event)),
                        placeholder: "Enter new password",
                        autocomplete: "new-password"
                      }, null, 512), [
                        [_vModelText, _ctx.newPassword]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmNewPassword) = $event)),
                        placeholder: "Confirm new password",
                        autocomplete: "new-password"
                      }, null, 512), [
                        [_vModelText, _ctx.confirmNewPassword]
                      ])
                    ]))
              ])
            ]),
            actions: _withCtx(() => [
              (!_ctx.resetPasswordStep)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    onClick: _ctx.requestPasswordReset
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("Send Reset Code", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_base_button, {
                    key: 1,
                    onClick: _ctx.confirmPasswordReset
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("Confirm", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])),
              _createVNode(_component_base_button, {
                mode: "flat",
                onClick: _ctx.closeForgotPasswordDialog
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["show", "onClose"]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("form", {
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
              class: "auth-form"
            }, [
              _createElementVNode("div", _hoisted_21, [
                (_ctx.mode === 'signup')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { invalid: _ctx.nameValidity === 'invalid' }])
                      }, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", { for: "name" }, "First Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "name",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.name) = $event)),
                          onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateInput('name', _ctx.name))),
                          placeholder: "Enter your first name"
                        }, null, 544), [
                          [
                            _vModelText,
                            _ctx.name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.nameValidity === 'invalid')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Please enter your First Name"))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { invalid: _ctx.lastNameValidity === 'invalid' }])
                      }, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", { for: "last_name" }, "Last Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "last_name",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.last_name) = $event)),
                          onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validateInput('lastName', _ctx.last_name))),
                          placeholder: "Enter your last name"
                        }, null, 544), [
                          [
                            _vModelText,
                            _ctx.last_name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.lastNameValidity === 'invalid')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Please enter your Last Name"))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { invalid: _ctx.emailValidity === 'invalid' }])
                }, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { for: "email" }, "E-mail", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "email",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.email) = $event)),
                    onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateInput('email', _ctx.email))),
                    placeholder: "name@example.com"
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.email,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.emailValidity === 'invalid')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.emailErrorMessage), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { invalid: _ctx.passwordValidity === 'invalid' }])
                }, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "password" }, "Password", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    id: "password",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.password) = $event)),
                    onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validateInput('password', _ctx.password))),
                    placeholder: "Enter your password"
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.password,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.passwordValidity === 'invalid')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Password must be at least 8 characters, include number, special, upper and lower case. "))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              (_ctx.mode === 'login')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openForgotPasswordDialog && _ctx.openForgotPasswordDialog(...args)), ["prevent"])),
                      class: "forgot-password-link"
                    }, " Forgot Password? ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_base_button, {
                  id: "login",
                  class: "primary-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.submitButtonCaption), 1)
                  ]),
                  _: 1
                })
              ])
            ], 32)
          ])
        ]))
  ]))
}